"use strict";
import React from "react";
import Rectangle from "./rectangle";
import Vector from "immutable-vector2d";
const RedactionElement = (props) => {
  return /* @__PURE__ */ React.createElement("g", { transform: `translate(${props.x},${props.y})` }, /* @__PURE__ */ React.createElement(
    Rectangle,
    {
      width: props.width,
      height: props.height,
      cursor: props.annotating ? "move" : "default",
      stroke: props.selected ? "#aaa" : "#ddd",
      strokeWidth: props.annotating ? 2 : 0,
      fill: "#fff"
    }
  ));
};
RedactionElement.calculateDragPoints = function(x, y, width, height) {
  return [
    { x, y },
    { x: x + width, y },
    { x: x + width, y: y + height },
    { x, y: y + height }
  ].map(Vector.fromObject);
};
RedactionElement.typeID = "Redaction";
RedactionElement.displayName = "Redaction";
RedactionElement.getBoundingBox = function(dragPoints) {
  const multipliers = [
    [-1, -1],
    [1, -1],
    [1, 1],
    [-1, 1]
  ];
  return dragPoints.map((point, idx) => {
    return [point.x + multipliers[idx][0], point.y + multipliers[idx][1]];
  });
};
export default RedactionElement;
